/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/radio-button/css/radio-button';
import './radiobutton-group.scss';
import './modifier/vertical-group.scss';
